"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var addPropTrackingRef_1 = __importDefault(require("./addPropTrackingRef"));
var addDebouncedHandler_1 = __importDefault(require("./addDebouncedHandler"));
var cleanupProps_1 = __importDefault(require("./cleanupProps"));
var addDebouncedCopy = function (waitInterval, propName, debouncedPropName) {
    var _a;
    var setterName = '_addDebouncedCopy-setter';
    var refName = '_addDebouncedCopy-ref';
    return ad_hok_1.flowMax(ad_hok_1.addState(debouncedPropName, setterName, function (_a) {
        var _b = propName, propValue = _a[_b];
        return propValue;
    }), addPropTrackingRef_1.default(propName, refName), ad_hok_1.addHandlers((_a = {},
        _a[setterName] = function (_a) {
            var _b = refName, ref = _a[_b], _c = setterName, setter = _a[_c];
            return function () {
                setter(ref.current);
            };
        },
        _a), []), addDebouncedHandler_1.default(waitInterval, setterName), ad_hok_1.addEffect(function (_a) {
        var _b = setterName, debouncedSetter = _a[_b];
        return function () {
            debouncedSetter();
        };
    }, [propName]), cleanupProps_1.default([setterName, refName]));
};
exports.default = addDebouncedCopy;
